// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { CtsGantryInitEventEType } from '../enum/cts-gantry-init-event-type';

@Injectable({ providedIn: 'root' })
export class CtsGantryInitEventStatusService {
  private readonly SUCCESS = 'success';
  private readonly WARNING = 'warning';
  private readonly ERROR = 'error';
  private readonly UNKNOWN = 'unknown';

  private readonly reduceError = 'Compl. w/ error';
  private readonly completedWithError = 'Completed with error';
  private readonly standBy = 'Standby';
  private readonly incomplete = 'Incomplete';

  private readonly statusMap = new Map<CtsGantryInitEventEType, string>([
    [CtsGantryInitEventEType.AUTOREBOOT, this.ERROR],
    [CtsGantryInitEventEType.COMPLETED_WITH_ERROR, this.ERROR],
    [CtsGantryInitEventEType.INCOMPLETE, this.ERROR],
    [CtsGantryInitEventEType.STANDBY, this.SUCCESS],
    [CtsGantryInitEventEType.UNKNOWN, this.ERROR],
  ]);

  private readonly reducedLabelMap = new Map<CtsGantryInitEventEType, string>([
    [CtsGantryInitEventEType.COMPLETED_WITH_ERROR, this.reduceError],
    [CtsGantryInitEventEType.INCOMPLETE, this.incomplete],
  ]);

  private readonly labelMap = new Map<CtsGantryInitEventEType, string>([
    [CtsGantryInitEventEType.COMPLETED_WITH_ERROR, this.completedWithError],
    [CtsGantryInitEventEType.INCOMPLETE, this.incomplete],
    [CtsGantryInitEventEType.STANDBY, this.standBy],
  ]);

  public translate(eventType: CtsGantryInitEventEType): string {
    return this.statusMap.get(eventType) ?? this.UNKNOWN;
  }

  public translateLabelReduced(eventType: CtsGantryInitEventEType): string {
    return this.reducedLabelMap.get(eventType) ?? this.UNKNOWN;
  }

  public translateLabel(eventType: CtsGantryInitEventEType): string {
    return this.labelMap.get(eventType) ?? this.UNKNOWN;
  }
}
